import { computed, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BaseStore } from '@client-libs';
import { map } from 'rxjs';

export interface IMenu {
  name: string;
  href?: string;
  children?: IMenu[];
  icon?: string;
  description?: string;

  /** 최고 관리자 전용 메뉴 여부 */
  super?: boolean;
}

type State = {
  menus: IMenu[];
  path: string;
};

/**
 * 레이아웃 및 메뉴 상태를 관리하는 스토어입니다.
 */
@Injectable({ providedIn: 'root' })
export class LayoutStore extends BaseStore<State> {
  menus$ = this.state$.pipe(map(state => state.menus));
  path$ = this.state$.pipe(map(state => state.path));

  menus = toSignal(this.menus$);
  path = toSignal(this.path$);

  /** 사이드바 접힘 상태 */
  sidebarCollapsed = signal(false);

  /** 사이드바 접힘 상태를 토글합니다. */
  toggleSidebar() {
    this.sidebarCollapsed.update(v => !v);
  }

  currentMenu = computed<IMenu | undefined>(() =>
    this.menus()?.find(menu => {
      if (menu.children) {
        return menu.children.some(child =>
          this.path()?.includes(child.href ?? '')
        );
      }

      return this.path()?.includes(menu.href ?? '');
    })
  );

  currentChildMenu = computed<IMenu | undefined>(() => {
    const currentMenu = this.currentMenu();

    if (currentMenu?.children) {
      return currentMenu.children.find(child =>
        this.path()?.includes(child.href ?? '')
      );
    }

    return undefined;
  });

  constructor() {
    super({
      menus: [],
      path: '',
    });
  }

  /** 현재 페이지 경로를 설정합니다. */
  setPath(path: string) {
    this.updateState({ path });
  }

  /** 레이아웃에서 사용할 메뉴 목록을 설정합니다. */
  setMenus(menus: IMenu[]) {
    this.updateState({ menus });
  }
}
